import styled from '../../../theme'
import is from 'typescript-styled-is'

const Option = styled.option<IOptionProps>`
  min-width: 0;
  ${is('disabled')`
    opacity: 0.5;
    cursor: not-allowed;
  `}
`

export default Option

export interface IOptionProps {
  icon?: string | React.ReactNode
  className?: string
  disableIcon?: boolean
}
